import { render } from "./FooterComponentOne.vue?vue&type=template&id=7fe1b42c&scoped=true"
import script from "./FooterComponentOne.vue?vue&type=script&lang=js"
export * from "./FooterComponentOne.vue?vue&type=script&lang=js"

import "./FooterComponentOne.vue?vue&type=style&index=0&id=7fe1b42c&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe1b42c"]])

export default __exports__